export default __webpack_public_path__ + "static/media/mob_preland_2.73880403.jpg";